import {
  FleetFireExtinguisherRow,
  FleetVehicleFireExtinguisher,
  FleetVehicleFireExtinguisherEditFormValues,
  FleetVehicleFireExtinguisherRow,
} from "./types";

export const transformFleetVehicleFireExtinguisherRow = (
  res: any
): FleetVehicleFireExtinguisherRow => {
  return {
    id: res.id,
    name: res.name,
    price: res.price,
    weight: res.weight,
    expirationDate: res.expirationDate,
    serialNumber: res.serialNumber,
  };
};

export const transformFleetFireExtinguisherRow = (
  res: any
): FleetFireExtinguisherRow => {
  return {
    id: res.id,
    name: res.name,
    price: res.price,
    weight: res.weight,
    expirationDate: res.expirationDate,
    serialNumber: res.serialNumber,
    vehicle: res.vehicle,
  };
};

export const transformFleetVehicleFireExtinguisherOnCreate = (
  formValues: FleetVehicleFireExtinguisherEditFormValues,
  vehicleId: string
): any => ({
  vehicleId: vehicleId,
  name: formValues.name,
  price: formValues.price,
  weight: formValues.weight,
  expirationDate: formValues.expirationDate,
  serialNumber: formValues.serialNumber,
});

export const transformFleetVehicleFireExtinguisherOnUpdate = (
  formValues: FleetVehicleFireExtinguisherEditFormValues,
  vehicleId: string
): any => ({
  id: formValues.id,
  vehicleId: vehicleId,
  name: formValues.name,
  price: formValues.price,
  weight: formValues.weight,
  expirationDate: formValues.expirationDate,
  serialNumber: formValues.serialNumber,
});

export const transformFleetVehicleFireExtinguisher = (
  res: any
): FleetVehicleFireExtinguisher => {
  return {
    id: res.id,
    name: res.name,
    price: res.price,
    weight: res.weight,
    expirationDate: res.expirationDate,
    serialNumber: res.serialNumber,
  };
};
